import React from "react";
import { Inbox, UserCheck, CheckCircle2, XCircle } from "lucide-react";

// Source unique de vérité pour les statuts d'une demande de tutoriel.
export const REQUEST_STATUS = {
  0: { label: "À traiter", modifier: "todo", Icon: Inbox },
  1: { label: "Assignée", modifier: "assigned", Icon: UserCheck },
  2: { label: "Terminée", modifier: "done", Icon: CheckCircle2 },
  3: { label: "Annulée", modifier: "cancelled", Icon: XCircle },
};

export const getStatusMeta = (status) =>
  REQUEST_STATUS[Number(status)] || REQUEST_STATUS[0];

const RequestStatusBadge = ({ status }) => {
  const { label, modifier, Icon } = getStatusMeta(status);
  return (
    <span className={`req-status req-status--${modifier}`}>
      <Icon size={13} />
      {label}
    </span>
  );
};

export default RequestStatusBadge;
